import React, { Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import PropTypes from 'prop-types'

import Question from '@aytm/app/swidget/questions/components/_base'
import Select from '@aytm/lib/rfd-ui/components/basic/select'
import { escapeText } from '@aytm/app/swidget/questions/lib/functions'
import { hapticEffects } from '../../base/lib/hapticEffects'

import locale from '@aytm/app/swidget/questions/locale'

import style from '@aytm/app/swidget/questions/styles/scx.module.scss'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import getCSRFToken from '@aytm/lib/csrf-token'
import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'
import Notice from '@aytm/app/swidget/questions/components/common/notice'

const DEFAULT_ANSWER = fromJS({ id: false })

export default class SCX extends Question {
  static propTypes = Object.assign(Question.propTypes, {
    cxUrl: PropTypes.string,
    validateUrl: PropTypes.string,
    optionsID: PropTypes.string
  })
  constructor(props) {
    super(props)
    this.selectOption = this.selectOption.bind(this);
    this.changeText = this.changeText.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.renderDesktop = this.renderDesktop.bind(this);
    this.renderMobile = this.renderMobile.bind(this);
    this.locale = locale(props.locale).get('questions')
    this.firstTouch = true
    this.state = {
      options: List([List([])]),
      fetching: List([true]),
      ...this.state
    }

    this.initAnswer(List([DEFAULT_ANSWER]))
  }

  componentDidMount() {
    super.componentDidMount()
    const self = this
    setTimeout(function () {
      self.requestCxData(0)
    }, 400)
  }

  requestCxData(i, id, callback) {
    const { cxUrl, cxData, locale, questionSchema } = this.props
    const url = cxUrl || questionSchema.getIn(['urls', 'cx_data'])
    const { options, answer } = this.state
    const csrfToken = getCSRFToken()
    const data = { locale: locale }
    const self = this
    self.setState({
      error: false
    })
    data[csrfToken[0]] = csrfToken[1]

    for (const key in this.props.data) {
      data[key] = this.props.data[key]
    }
    for (const key in cxData) {
      data[key] = cxData[key]
    }
    if (i > 0) {
      data['q_answers'] = answer
        .setSize(i)
        .reduce((prev, cur, j) => prev.push(i === j + 1 ? id : cur.get('id')), List([]))
    }
    data['uid'] = questionSchema.getIn(['selectoptions', 'uid'])

    const dataToCx = data => {
      const newOptions = options.set(
        i,
        data.v.reduce(
          (prev, cur, i) =>
            prev.push(
              fromJS({
                id: cur.id || 'a' + (i + 1),
                value: i + 1,
                text: cur.l.toString(),
                oe: cur.o,
                // eslint-disable-next-line no-useless-escape
                skipFilter: Boolean(/^(other|n[/\\]a)/i.test(cur.l.toString())),
                children: cur.v,
                t: data.t,
                placeholder: cur.t,
                validate: true === cur.validate
              })
            ),
          List([])
        )
      )
      self.setState({
        options: newOptions,
        fetching: List([])
      })
      if ('function' == typeof callback) callback(newOptions)
    }

    if (questionSchema.get('sxc_data')) {
      dataToCx(questionSchema.get('sxc_data').toJS())
      return
    }

    this.setState({ fetching: List([]).set(i, true) })
    railsPostFetch(url, {
      body: JSON.stringify(data),
      mode: 'cors'
    })
      .then(response => response.json())
      .then(data => {
        if ('ok' === data.status) {
          dataToCx(data.data)
          if (
            self.props.theme != 'mobile' &&
            self['refSelect' + i] &&
            self['refSelect' + i].refFocusHolder &&
            !this.firstTouch
          )
            self['refSelect' + i]?.refFocusHolder?.focus()
        }
      })
      .catch(_error => {
        const newOptions = options.setSize(i)
        self.setState(
          {
            options: newOptions,
            error: true
          },
          () => {
            self.updateAnswer(answer.setSize(i))
          }
        )
        // if ('function' == typeof callback) callback(newOptions)
      })
  }

  validate(answerModel) {
    const validateObj = answerModel.find(el => el && el.get('validate') && true !== el.get('validated'))

    if (validateObj) {
      return Map({ valid: false })
    } else {
      if (answerModel) {
        // todo: comments, validated
        return Map({
          valid: answerModel.size && answerModel.reduce((prev, cur) => prev && Boolean(cur && cur.get('value')), true)
        })
      }

      return Map({ valid: false })
    }
  }

  // response: [{id: 'a1', c: 'hello world'}]
  backendResponse(answerModel) {
    if (!answerModel) return []

    return answerModel.reduce((prev, cur) => {
      prev.push(!cur.get('comment') ? { id: cur.get('id') } : { id: cur.get('id'), c: cur.get('comment') })
      return prev
    }, [])
  }

  selectOption(v, i, newOptions, newAnswer) {
    const { answer, options, fetching } = this.state
    if (fetching.get(i)) return
    this.firstTouch = false
    const currentOptions = newOptions ? newOptions : options
    const currentAnswer = newAnswer ? newAnswer : answer
    hapticEffects.selection()

    const focus = () => {
      const self = this
      setTimeout(() => {
        if (self.props.theme != 'mobile' && self['refSelect' + i] && self['refSelect' + i].refFocusHolder)
          self['refSelect' + i].refFocusHolder.focus()
      }, 200)
    }
    const hotUpdateAnswer = newOptions => {
      const newAnswer = currentAnswer
        .setSize(i + 1)
        .set(i, v.set('comment', ''))
        .set(i + 1, DEFAULT_ANSWER)
      this.updateAnswer(newAnswer)
      focus()
      if (1 == newOptions.get(i + 1).size) this.selectOption(newOptions.getIn([i + 1, 0]), i + 1, newOptions, newAnswer)
    }
    if (!v.get('children') || (!v.get('children').size && 'request' != v.get('children'))) {
      this.updateAnswer(currentAnswer.setSize(i + 1).set(i, v.set('comment', '')))
      this.setState({ placeholder: v.get('t') })
      focus()
    } else if ('request' == v.get('children')) {
      this.requestCxData(i + 1, v.get('id'), newOptions => hotUpdateAnswer(newOptions))
    } else {
      const updatedOptions = currentOptions.set(
        i + 1,
        v.get('children').reduce(
          (prev, cur, i) =>
            prev.push(
              fromJS({
                id: cur.get('id') || 'a' + (i + 1),
                value: i + 1,
                text: cur.get('l').toString(),
                oe: cur.get('o'),
                children: cur.get('v'),
                placeholder: cur.get('t'),
                skipFilter: Boolean(
                  /^(other|n[/\\]a)/i
                    // eslint-disable-next-line no-useless-escape
                    .test(cur.get('l').toString())
                ),
                t: v.get('placeholder')
              })
            ),
          List([])
        )
      )
      this.setState(
        {
          options: updatedOptions
        },
        () => {
          hotUpdateAnswer(updatedOptions)
        }
      )
    }
  }

  changeText(text, i) {
    const { answer } = this.state
    this.updateAnswer(answer.setIn([i, 'comment'], text).setIn([i, 'validated'], null))
  }

  onFocus() {
    hapticEffects.soft()
  }

  renderContent() {
    const { options, answer, error, fetching } = this.state
    const { showErrors } = this.props

    return (
      <Fragment>
        <Notice
          showErrors={showErrors}
          text={this.locale.getIn(['cx', 'note'])}
          data-testid="SW-CX-ValidationMessage"
        />

        {answer.map((answerItem, i) => {
          const comment = answer.getIn([i, 'comment']) || ''
          const commentRows = Math.max((comment.match(/\n/g) || []).length + 1, 3, comment.length / 50)
          return (
            <div key={i} className={style.selectContainer} data-testid="SW-CX-Combobox" style={{ zIndex: 110 - i }}>
              {options.get(i) && (options.get(i).size > 1 || !answerItem.get('oe')) && (
                <Select
                  options={options.get(i) || List([])}
                  newIcon={true}
                  // width="100%"
                  value={answer.getIn([i, 'value']) || null}
                  placeholder={escapeText(
                    options.getIn([i, 0, 't']) ||
                      options.getIn([i, 0, 'placeholder']) ||
                      (options.get(i).size ? this.locale.getIn(['pleaseSelect']) : '')
                  )}
                  onSelect={v => this.selectOption(v, i)}
                  onFocus={this.onFocus}
                  showSelected={true}
                  filterOptions={true}
                  filterStrategy="firstChar"
                  ref={this.saveRef('Select' + i)}
                  theme="swidget"
                  fetching={fetching.get(i)}
                />
              )}
              {answerItem.get('oe') && (
                <div className={style.openEnded} data-testid="SW-CX-OpenEnded">
                  <span
                    className={style.placeholder}
                    dangerouslySetInnerHTML={{
                      __html: options.getIn([i, 0, 't']) || options.getIn([i, 0, 'placeholder'])
                    }}
                  />
                  <TextField
                    error={showErrors && !comment.length}
                    rows={commentRows}
                    onChange={v => this.changeText(v, i)}
                    debounce={100}
                    placeholder={escapeText(answerItem.get('text'))}
                    value={comment}
                    resizableHeight={true}
                    ref={this.saveRef('Comment')}
                    onFocus={this.onFocus}
                    data-testid="SW-CX-Input"
                  />
                </div>
              )}
            </div>
          )
        })}
        {error && (
          <Notice
            data-testid="SW-CX-Error"
            text="Something went wrong, please refresh the page and try again"
            showErrors={true}
          />
        )}
      </Fragment>
    )
  }

  renderDesktop() {
    return (
      <div data-testid="SW-CX" className={style.component}>
        {this.renderContent()}
      </div>
    )
  }

  renderMobile() {
    return (
      <div data-testid="SW-CX" className={`${style.component} ${style.mobile}`}>
        {this.renderContent()}
      </div>
    )
  }
}
